// extracted by mini-css-extract-plugin
export default {"wrapper":"AreaEditForm_wrapper__nUF0x"};